import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { breadcrumbApi } from './breadcrumbApi';
import { runRtkQuery } from '../helperFn';

export const accountApi = createApi({
  reducerPath: 'accountApi',
  baseQuery: baseQuery,
  tagTypes: ['detail', 'accountList'],
  endpoints: (builder) => ({
    getAccount: builder.query({
      query: (payload) => ({
        url: '/authrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        await runRtkQuery(payload, dispatch, queryFulfilled, 'getAccount');
      },
      providesTags: ['detail'],
    }),

    updateAccountInformation: builder.mutation({
      query: (payload) => ({
        url: '/authrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        await runRtkQuery(payload, dispatch, queryFulfilled, 'updateAccountInformation');
        dispatch(breadcrumbApi.util.invalidateTags(['breadcrumb']));
      },
      invalidatesTags: ['detail'],
    }),

    addNewAccount: builder.mutation({
      query: (payload) => ({
        url: '/authrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        await runRtkQuery(payload, dispatch, queryFulfilled, 'addNewAccount');
      },
      invalidatesTags: ['accountList'],
    }),

    getAccountList: builder.query({
      query: (payload) => ({
        url: '/authrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        await runRtkQuery(payload, dispatch, queryFulfilled, 'getAccountList');
      },
      providesTags: ['accountList'],
    }),
  }),
});

export const {
  useLazyGetAccountQuery,
  useGetAccountQuery,
  useLazyGetAccountListQuery,
  useGetAccountListQuery,
  useAddNewAccountMutation,
  useUpdateAccountInformationMutation,
} = accountApi;